
import React, { useState, useEffect } from 'react';
import './QcTpdsCompletedInspections.css';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import ExcelJS from 'exceljs';
import pds from './pds.PNG';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
const QcTpdsCompletedInspectionsToday = () => {
    const [stockData, setStockData] = useState([]);

    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;
    useEffect(() => {
        //console.log('Component Mounted or Re-rendered');
        const fetchData = async () => {
            const todayDate = format(new Date(), 'yyyy-MM-dd');

            try {
                const response = await axios.get(`${baseUrl}/completed/godown/4/date/${todayDate}`, {
                    headers: {
                        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
                    },
                });

                if (response.data && response.data.data) {
                    setStockData(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching the data: ", error);
            }
        };

        fetchData();
    }, []);
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };

    const downloadPDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.addImage(pds, 'PNG', 9, 1, 193, 36);  // Image format: 'PNG'
        doc.setFontSize(18);

        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = currentDate.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;

        doc.text(`QC-CMR_Inspections Completed On ${formattedDate}`, 46, 40);

        let currentYPosition = 44;
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(12);
        doc.text(`Report Date: ${formattedDateTime}`, 196, currentYPosition + 3, { align: 'right' });
        currentYPosition += 5;

        let currentXPosition = 20;
        const headers = ['S.No', 'District', 'Sub-Division', 'Block', 'Panchayat', 'Godown ID', 'Inspecting Officer', 'Inspecting Date'];
        const rows = stockData.map((data, index) => [
            index + 1,
            capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.district?.districtName || 'N/A'),
            capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.subDivisionName || 'N/A'),
            capitalizeFirstLetter(data.godown?.panchayat?.block?.blockName || 'N/A'),
            capitalizeFirstLetter(data.godown?.panchayat?.panchayatName.trim() || 'N/A'),
            data.godown?.godownId || 'N/A',
            formatFullName(data.poimsUser?.fullname || 'N/A'),
            format(new Date(data.createdAt), 'dd-MM-yyyy'),
        ]);

        doc.autoTable({
            head: [headers],
            body: rows,
            startY: currentYPosition,
            startX: currentXPosition,
            theme: 'grid',
            columnStyles: {
                0: { cellWidth: 12, halign: 'center' },
                1: { cellWidth: 20, halign: 'left' },
                2: { cellWidth: 25, halign: 'left' },
                3: { cellWidth: 25, halign: 'left' },
                4: { cellWidth: 25, halign: 'left' },
                5: { cellWidth: 25, halign: 'right' },
                6: { cellWidth: 30, halign: 'left' },
                7: { cellWidth: 25, halign: 'right' },
            },
            tableWidth: 'auto',
            margin: {
                horizontal: 10,
                top: 10,
                bottom: 10,
            },
            pageBreak: 'auto',
            showHead: 'firstPage',
            styles: {
                fontSize: 10,
                textColor: 0,
            },
            headStyles: {
                fontSize: 10,
                fontStyle: 'bold',
                textColor: [42, 109, 139],
                fillColor: [211, 211, 211],
            }
        });
        doc.save('QC_CMR_completed_inspection_today.pdf');
    };

    const downloadExcel = () => {
        const workbook = new ExcelJS.Workbook();
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = currentDate.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;

        const worksheet = workbook.addWorksheet(`Inspections Completed On ${formattedDate}`);
        worksheet.mergeCells('A1:H1');
        worksheet.getCell('A1').value = `QC-CMR_Inspections Completed On ${formattedDate}`;
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getRow(1).font = { bold: true, size: 12 };
        worksheet.getRow(1).alignment = { horizontal: 'center' };
        worksheet.getRow(1).font = { size: 16, bold: true, color: { argb: 'F7912B' } };
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: 'F7912B' },
        };

        worksheet.mergeCells('A2:H2');
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        worksheet.getCell('A2').value = `Report Date : ${formattedDateTime}`;
        worksheet.getRow(2).font = { bold: true, size: 12 };
        worksheet.getRow(2).alignment = { horizontal: 'right' };
        worksheet.getRow(2).font = { size: 11, bold: true, color: { argb: '000000' } };
        worksheet.getRow(2).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' },
            color: { argb: 'F7912B' },
        };

        worksheet.addRow(['S.No', 'District', 'Sub-Division', 'Block', 'Panchayat', 'Godown ID', 'Inspecting Officer', 'Inspecting Date']);

        for (let col = 1; col <= 8; col++) {
            const cell = worksheet.getCell(3, col);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } },
            };
        }

        worksheet.columns = [
            { key: 'A', width: 10 },
            { key: 'B', width: 20 },
            { key: 'C', width: 20 },
            { key: 'D', width: 20 },
            { key: 'E', width: 20 },
            { key: 'F', width: 15 },
            { key: 'G', width: 25 },
            { key: 'H', width: 18 },
        ];

        stockData.forEach((data, index) => {
            const dataRow = worksheet.addRow([
                index + 1,
                capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.district?.districtName || 'N/A'),
                capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.subDivisionName || 'N/A'),
                capitalizeFirstLetter(data.godown?.panchayat?.block?.blockName || 'N/A'),
                capitalizeFirstLetter(data.godown?.panchayat?.panchayatName.trim() || 'N/A'),
                data.godown?.godownId || 'N/A',
                formatFullName(data.poimsUser?.fullname || 'N/A'),
                format(new Date(data.createdAt), 'dd-MM-yyyy'),
            ]);

            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {
                    cell.alignment = { horizontal: 'center' };
                } else if (colNumber === 6 || colNumber === 8) {
                    cell.alignment = { horizontal: 'right' };
                } else {
                    cell.alignment = { horizontal: 'left' };
                }
            });
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'QC_CMR_completed_inspection_today.xlsx';
            link.click();
        });
    };

    const capitalizeFirstLetter = (text) => {
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return '';
    };
    const handleViewReportClick = (godownId, date, username) => {
        // Save fpsId and date to localStorage or sessionStorage
        localStorage.setItem('godownId', godownId);
        localStorage.setItem('startTime', date);
        localStorage.setItem('username', username); // Make sure username is set here
    };

    return (
        <div className="QcTpdsInspectionsToday">
            <div className="QcTpdsInspectionsToday-repo">

                <div className="QcTpdsInspectionsToday-header-15">
                    <button className="QcTpdsInspectionsToday-btn" onClick={downloadPDF}>DOWNLOAD PDF</button>
                    <button className="QcTpdsInspectionsToday-btn" onClick={downloadExcel}>DOWNLOAD XLSX</button>
                </div>
                <div className='cmrInspections-text'><h3>QC-TPDS Completed Inspections</h3></div>
                <div className='completedInspection-scroll'>
                    <table className="QcTpdsInspectionsToday-table">
                        <thead>
                            <tr className="QcTpdsInspectionsToday-tr">
                                <th>S.No</th>
                                <th>District</th>
                                <th>Sub-Division</th>
                                <th>Block</th>
                                <th>Panchayat</th>
                                <th>Godown ID</th>
                                <th>Inspection Officer</th>
                                <th>Inspection Date</th>
                                <th>View Report</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stockData.map((data, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.district?.districtName)}</td>
                                    <td>{capitalizeFirstLetter(data.godown?.panchayat?.block?.subDivision?.subDivisionName)}</td>
                                    <td>{capitalizeFirstLetter(data.godown?.panchayat?.block?.blockName)}</td>
                                    <td>{capitalizeFirstLetter(data.godown?.panchayat?.panchayatName)}</td>
                                    <td>{data.godown?.godownId}</td>
                                    <td>{data.poimsUser?.fullname}</td>
                                    <td>{format(new Date(data.createdAt), 'dd-MM-yyyy')}</td>
                                    <td>
                                        <Link
                                            to="/qcTPDSViewReport"
                                            onClick={() =>
                                                handleViewReportClick(
                                                    data.godown?.godownId,
                                                    // format(new Date(data.startTime), 'yyyy-MM-dd'),
                                                    data.startTime,
                                                    data.poimsUser?.username,
                                                )
                                            }
                                            target="_blank" // Open in a new tab
                                            rel="noopener noreferrer" // For security reasons (to prevent vulnerabilities)
                                        >
                                            View Report
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default QcTpdsCompletedInspectionsToday;
